import { Button, Form, Input, List, NavBar, Popup, SearchBar, Toast } from 'antd-mobile';
import { ScanningOutline } from 'antd-mobile-icons';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { borrowDevice, listOtherUser, loadDeviceByAssetNo } from '../componet/service';

import { Html5Qrcode } from 'html5-qrcode';
import '../styles/BorrowPage.css';

const BorrowPage = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [device, setDevice] = useState(null);
    const [userOptions, setUserOptions] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [visible, setVisible] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [scannerVisible, setScannerVisible] = useState(false);
    const scannerRef = useRef(null);

    useEffect(() => {
        loadUser();
        return () => {
            if (scannerRef.current) {
                scannerRef.current.clear();
            }
        };
    }, [])
    const loadUser = async () => {
        const res = await listOtherUser();
        if (res.data) {
            const data = res.data;
            setUserOptions(data);
            setFilteredUsers(data);
        }
    }
    // 处理搜索
    const handleSearch = (value) => {
        setSearchValue(value);
        if (!value) {
            setFilteredUsers(userOptions);
        } else {
            const filtered = userOptions.filter(user =>
                user.name.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredUsers(filtered);
        }
    };

    // 选择用户
    const selectUser = (user) => {
        form.setFieldsValue({ relatedUserId: user.id });
        setVisible(false);
    };

    // 获取当前选中的用户名
    const getSelectedUserName = () => {
        const userId = form.getFieldValue('relatedUserId');
        if (!userId) return '请选择关系人';
        const user = userOptions.find(u => u.id === userId);
        return user ? user.name : '请选择关系人';
    };

    // 返回上一页
    const onBack = () => {
        navigate(-1);
    };

    // 扫码功能
    const handleScan = () => {
        console.log('扫码功能触发');
        setScannerVisible(true);
        setTimeout(() => {
            initScanner();
        }, 100);
    };

    // 初始化扫码器
    const initScanner = () => {
        const scannerContainer = document.getElementById('scanner-container');
        if (!scannerContainer) return;

        if (scannerRef.current) {
            scannerRef.current.clear();
        }

        const html5QrCode = new Html5Qrcode("scanner-container");
        scannerRef.current = html5QrCode;

        html5QrCode.start(
            { facingMode: "environment" },
            {
                fps: 10,
                qrbox: { width: 250, height: 250 },
            },
            (decodedText) => {
                // 扫码成功后的回调
                html5QrCode.stop().then(() => {
                    setScannerVisible(false);
                    // 设置资产编号并触发数据加载
                    form.setFieldsValue({ assetNo: decodedText });
                    loadDeviceData(decodedText);
                    Toast.show({
                        content: '扫码成功',
                        position: 'bottom',
                    });
                });
            },
            (errorMessage) => {
                // 保持静默，不处理错误
                console.log(errorMessage);
            }
        ).catch(err => {
            Toast.show({
                content: '无法启动相机',
                position: 'bottom',
            });
            setScannerVisible(false);
        });
    };

    // 关闭扫码器
    const closeScanner = () => {
        if (scannerRef.current) {
            scannerRef.current.stop().then(() => {
                setScannerVisible(false);
            }).catch(err => {
                setScannerVisible(false);
            });
        } else {
            setScannerVisible(false);
        }
    };

    // 加载设备数据
    const loadDeviceData = async (assetNo) => {
        if (!assetNo) return;
        try {
            const res = await loadDeviceByAssetNo(assetNo);
            if (res.data) {
                form.setFieldsValue(res.data);
                setDevice(res.data);
            } else {
                setDevice(null);
                const allFields = form.getFieldsValue(true);
                const resetFields = Object.keys(allFields).reduce((acc, field) => {
                    if (field !== 'assetNo' && field !== 'relatedUserId') {
                        acc[field] = '';
                    }
                    //acc[field] = field === 'assetNo' || field === 'relatedUserId' ? assetNo : '';
                    return acc;
                }, {});
                form.setFieldsValue(resetFields);
            }
        } catch (error) {
            Toast.show({
                content: '获取设备信息失败',
                position: 'bottom',
            });
        }
    };

    // 处理资产编号输入完成事件
    const changeAssetNo = (value) => {
        const assetNo = value;
        if (assetNo) {
            loadDeviceData(assetNo);
        }
    };

    // 提交表单
    const onFinish = async () => {
        const values = form.getFieldsValue(true);
        if (!values.relatedUserId) {
            Toast.show({
                content: '请选择关系人',
                position: 'bottom',
            });
            return;
        }
        const res = await borrowDevice(values.assetNo, values.relatedUserId);
        if (res.code !== 0) {
            Toast.show({
                content: res.msg,
                position: 'bottom',
            });
            return;
        } else {
            const audio = new Audio('./lrcg.mp3');
            audio.play();
            Toast.show({
                content: '设备已成功借出',
                position: 'bottom',
            });
            navigate(-1);
        }
    };

    return (
        <div className="borrow-page">
            <NavBar back="返回" onBack={onBack} right={
                <Button
                    size="small"
                    onClick={handleScan}
                    className="scan-button"
                >
                    <ScanningOutline /> 扫码
                </Button>
            }>
                设备出借
            </NavBar>

            <div className="form-container">
                <Form
                    form={form}
                    layout="horizontal"
                    footer={
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '16px 0' }}>
                            <Button block disabled={device === null || device.status !== '正常' || !form.getFieldValue('relatedUserId')} onClick={onFinish} color="primary" style={{ marginRight: 8 }}>
                                确认
                            </Button>
                            <Button block onClick={() => {
                                form.resetFields();
                                setDevice(null);
                            }}>
                                重置
                            </Button>
                        </div>
                    }
                >
                    <Form.Item
                        name="assetNo"
                        label="资产编号"
                        rules={[{ required: true, message: '请输入资产编号' }]}
                    >
                        <Input placeholder="请输入资产编号" onChange={changeAssetNo} />
                    </Form.Item>
                    <Form.Item
                        name="relatedUserId"
                        label="关系人"
                        rules={[{ required: true, message: '请选择关系人' }]}
                    >
                        <Button
                            onClick={() => {
                                setSearchValue('');
                                setFilteredUsers(userOptions);
                                setVisible(true);
                            }}
                            fill="none"
                            className="picker-button"
                        >
                            {getSelectedUserName()}
                        </Button>
                    </Form.Item>
                    <Form.Item name="typeName" label="设备分类">
                        <Input readOnly placeholder="设备分类" />
                    </Form.Item>
                    <Form.Item name="name" label="设备名称">
                        <Input readOnly placeholder="设备名称" />
                    </Form.Item>
                    <Form.Item name="model" label="设备型号">
                        <Input readOnly placeholder="设备型号" />
                    </Form.Item>
                    <Form.Item name="remark" label="备注信息">
                        <Input readOnly placeholder="备注信息" />
                    </Form.Item>
                    <Form.Item name="currentBorrower" label="出借人">
                        <Input readOnly placeholder="出借人" />
                    </Form.Item>

                    <Form.Item name="lastBorrowTime" label="出借时间">
                        <Input readOnly placeholder="出借时间" />
                    </Form.Item>
                    <Form.Item name="status" label="设备状态">
                        <Input readOnly placeholder="设备状态" />
                    </Form.Item>
                    <Form.Item name="borrowStatus" label="出借状态">
                        <Input readOnly placeholder="出借状态" />
                    </Form.Item>
                </Form>
            </div>
            <Popup
                visible={visible}
                onMaskClick={() => setVisible(false)}
                position="bottom"
                bodyStyle={{ height: '60vh' }}
            >
                <div className="user-picker-popup">
                    <SearchBar
                        placeholder="搜索关系人"
                        value={searchValue}
                        onChange={handleSearch}
                        style={{ padding: '8px' }}
                    />
                    <List style={{ maxHeight: 'calc(60vh - 56px)', overflow: 'auto' }}>
                        {filteredUsers.map(user => (
                            <List.Item
                                key={user.id}
                                onClick={() => selectUser(user)}
                                arrow={false}
                            >
                                {user.name}
                            </List.Item>
                        ))}
                        {filteredUsers.length === 0 && (
                            <div className="no-result">没有找到匹配的用户</div>
                        )}
                    </List>
                </div>
            </Popup>
            {scannerVisible && (
                <div className="scanner-overlay">
                    <div className="scanner-header">
                        <Button onClick={closeScanner} className="close-button">关闭</Button>
                    </div>
                    <div id="scanner-container" className="scanner-container"></div>
                    <div className="scanner-hint">
                        <p>请将二维码对准扫描框</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BorrowPage;